import React from 'react';
import BaseIcon from './BaseIcon.js';

const IconNeutral = function ({ size }) {
  return (
    <BaseIcon viewBox="0 0 24 24" size={size}>
      <path d="M18,11H6c-1.104,0-2,0.896-2,2s0.896,2,2,2h12c1.104,0,2-0.896,2-2S19.104,11,18,11z" />
    </BaseIcon>
  );
}

export default IconNeutral;
